"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ArrowGreen = _interopRequireDefault(require("../Welcome/images/ArrowGreen.svg"));

var _FadeIn = require("@jobmatchme/ui/es/components/FadeIn");

var _Authentication = require("../../provider/Authentication");

var _Matches = require("../../provider/Matches");

var _Profile = require("../../provider/Profile");

var _Route = require("../../provider/Route");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _JmmLoader = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/JmmLoader"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var translateNs = 'pc-matching:MatchesScreen';

var MatchesScreen = function MatchesScreen() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useContext = (0, _react.useContext)(_Profile.ProfileContext),
      discriminator = _useContext.discriminator;

  var _useContext2 = (0, _react.useContext)(_Matches.MatchesContext),
      list = _useContext2.list,
      status = _useContext2.status;

  var _useContext3 = (0, _react.useContext)(_Authentication.AuthenticationContext),
      isAuthenticated = _useContext3.isAuthenticated;

  var matchesNumber = (list || []).length;
  var matchesLoading = status !== 'done';

  var _useContext4 = (0, _react.useContext)(_Route.RouteActionsContext),
      routeInternal = _useContext4.routeInternal,
      routeExternal = _useContext4.routeExternal;

  var showMatches = function showMatches() {
    return routeInternal('appHome');
  };

  var goToLogin = function goToLogin() {
    return routeExternal('pcLogin');
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    className: _styleModule.default.buttonWrapper,
    children: !isAuthenticated ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
        component: "p",
        className: _styleModule.default.tip,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          children: t("".concat(translateNs, ".tip"))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          children: t("".concat(translateNs, ".tip2"))
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: "primary",
        variant: "contained",
        round: true,
        flat: true,
        extraBold: true,
        texttransform: "none",
        className: _styleModule.default.saveBtn,
        onClick: goToLogin,
        children: t("".concat(translateNs, ".button"))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: _styleModule.default.arrow,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _ArrowGreen.default,
          className: _styleModule.default.colorRevert,
          alt: ""
        })
      })]
    }) : matchesLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FadeIn.SimpleFadeIn, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_JmmLoader.default, {})
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FadeIn.SimpleFadeIn, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        component: "p",
        className: _styleModule.default.welcome,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          children: t("".concat(translateNs, ".description_plural"), {
            count: matchesNumber
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: "primary",
        variant: "contained",
        round: true,
        flat: true,
        bold: true,
        texttransform: "none",
        onClick: showMatches,
        className: _styleModule.default.button,
        children: matchesNumber ? t("".concat(translateNs, ".showMatches"), {
          count: matchesNumber
        }) : t("".concat(translateNs, ".showNoMatches"))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: _styleModule.default.arrow,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _ArrowGreen.default,
          className: "".concat(discriminator === 'truck' ? _styleModule.default.colorRevert : ''),
          alt: ""
        })
      })]
    })
  });
};

var _default = /*#__PURE__*/_react.default.memo(MatchesScreen);

exports.default = _default;